// extracted by mini-css-extract-plugin
export default {"relyingPartyPermissionsContainer":"relying-party-permissions-container__relying-party-permissions-container__Ht3KO"};